"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.monochrome.dark, ";border:1px solid ", theme.color.monochrome.medium, ";background-color:", theme.color.monochrome.white, ";padding:6px;border-radius:4px;margin:-8px auto 8px;text-align:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=AllSelection.styles.js.map